import { render, staticRenderFns } from "./LoadingModule.vue?vue&type=template&id=97de4e18&scoped=true&"
import script from "./LoadingModule.vue?vue&type=script&lang=js&"
export * from "./LoadingModule.vue?vue&type=script&lang=js&"
import style0 from "./LoadingModule.vue?vue&type=style&index=0&id=97de4e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97de4e18",
  null
  
)

component.options.__file = "LoadingModule.vue"
export default component.exports